var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("navbar"),
      _vm._m(0),
      _c(
        "div",
        { staticClass: "content search-content" },
        [
          _c("search-com", {
            attrs: { type: "logistics" },
            on: {
              outputSearchData: _vm.receiveSearchData,
              searchBasic: function ($event) {
                return _vm.getStatistics($event)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.baseData.loading,
              expression: "baseData.loading",
            },
          ],
          staticClass: "content",
        },
        [
          _c(
            "div",
            { staticClass: "base-data-list" },
            [
              _vm._l(_vm.baseData.list, function (item, index) {
                return [
                  _c("basic-data", {
                    key: index,
                    attrs: { basicDataItem: item, basicDataItemIndex: index },
                  }),
                ]
              }),
            ],
            2
          ),
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.selectOutboundGoods.loading,
              expression: "selectOutboundGoods.loading",
            },
          ],
          staticClass: "content achievement",
        },
        [
          _c("h3", { staticClass: "card-title" }, [
            _c("label", [_vm._v(_vm._s(_vm.selectOutboundGoods.title))]),
            _c(
              "div",
              { staticClass: "staff-button-list" },
              [
                _c("el-button", {
                  staticClass: "download-table",
                  attrs: { size: "small", icon: "el-icon-download" },
                  on: {
                    click: function ($event) {
                      return _vm.onDownload("staff")
                    },
                  },
                }),
              ],
              1
            ),
          ]),
          _c("search-com-company", {
            attrs: {
              type: _vm.selectOutboundGoods.type,
              dateArr: _vm.selectOutboundGoods.dateArr,
            },
            on: { outputSearchData: _vm.receiveSearchData },
          }),
          _c("data-board-table", {
            attrs: {
              dataList: _vm.selectOutboundGoods.list,
              config: _vm.selectOutboundGoods.config,
              sortObj: _vm.selectOutboundGoods.sortObj,
            },
            on: { tableShowDetail: _vm.showDetail },
          }),
          _vm.selectOutboundGoods.list.length > 0
            ? _c(
                "div",
                { staticClass: "page" },
                [
                  _c("el-pagination", {
                    attrs: {
                      background: "",
                      "current-page": _vm.selectOutboundGoods.page.pageNo,
                      "page-sizes": [3, 5, 10, 20, 50],
                      "page-size": _vm.selectOutboundGoods.page.pageSize,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.selectOutboundGoods.page.totalNum,
                    },
                    on: {
                      "size-change": _vm.onChangeOutboundSizePage,
                      "current-change": _vm.onChangeOutboundCurrentPage,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content page-title" }, [
      _c("h2", [_vm._v("物流数据看板")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }